import { apiSlice } from "../../apiSlice";
export const ingepropApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataGraphic: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    generateExcel: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/generateExcel`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getDataGroups: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/getDataGroups`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getCliReport: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/clients`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getExecReport: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/executive`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getExecAlerts: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/executive/alerts`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getCliKpis: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/clikpis`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
  }),
});

export const {
  useGetDataGraphicMutation,
  useGenerateExcelMutation,
  useGetDataGroupsMutation,
  useGetCliReportMutation,
  useGetExecReportMutation,
  useGetExecAlertsMutation,
  useGetCliKpisMutation,
} = ingepropApiSlice;
